<template>
    <div>
        <ul :class="['nav', pills ? 'nav-pills' : 'nav-tabs', fill && 'nav-fill', justified && 'nav-justified']" role="tablist" @keydown="onKeydown">
            <li v-for="(tab, index) in tabs" :key="tab.$.uid" :class="['nav-item', tab.titleItemClass]">
                <button
                    type="button"
                    :class="['nav-link', 'w-100', index === activeIndex && 'active', index === activeIndex && activeNavItemClass]"
                    role="tab"
                    :id="tabId(tab)"
                    :aria-controls="paneId(tab)"
                    :disabled="tab.disabled"
                    :aria-selected="String(index === activeIndex)"
                    :tabindex="index === activeIndex ? 0 : -1"
                    @click="select(index)"
                ><template v-if="tab.$slots.title"><slot-proxy :render-slot="tab.$slots.title" /></template><template v-else>{{ tab.title }}</template></button>
            </li>
        </ul>
        <div class="tab-content"><slot /></div>
    </div>
</template>
<script>
import { emitModel } from "./model";
const SlotProxy = {
    props: { renderSlot: { type: Function, required: true } },
    setup(props) { return () => props.renderSlot(); },
};
export default {
    name: "SbTabs",
    emits: ["update:modelValue", "changed"],
    components: { SlotProxy },
    provide() { return { sbTabs: this }; },
    props: {
        modelValue: { default: undefined },
        pills: { type: Boolean, default: false },
        fill: { type: Boolean, default: false },
        justified: { type: Boolean, default: false },
        activeNavItemClass: { type: [String, Array, Object], default: null },
        id: { type: String, default: "sb-tabs" },
    },
    data() { const value = this.modelValue; return { tabs: [], localIndex: Number(value ?? 0) }; },
    computed: { activeIndex() { return Math.max(0, Math.min(this.localIndex, this.tabs.length - 1)); } },
    watch: {
        modelValue(value) { if (value !== undefined) { this.setIndex(value, false); } },
    },
    methods: {
        register(tab) { if (!this.tabs.includes(tab)) { this.tabs.push(tab); this.$forceUpdate(); } },
        unregister(tab) { this.tabs = this.tabs.filter((item) => item !== tab); },
        tabId(tab) { return `${this.id}-tab-${tab.$.uid}`; },
        paneId(tab) { return `${this.id}-pane-${tab.$.uid}`; },
        select(index) { if (!this.tabs[index]?.disabled) { this.setIndex(index); } },
        setIndex(index, emit = true) { this.localIndex = Number(index); if (emit) { emitModel(this, this.activeIndex); this.$emit("changed", this.activeIndex); } },
        onKeydown(event) {
            if (!["ArrowLeft", "ArrowRight", "Home", "End"].includes(event.key)) { return; }
            event.preventDefault();
            let index = event.key === "Home" ? 0 : event.key === "End" ? this.tabs.length - 1 : this.activeIndex + (event.key === "ArrowLeft" ? -1 : 1);
            for (let count = 0; count < this.tabs.length; count += 1) {
                index = (index + this.tabs.length) % this.tabs.length;
                if (!this.tabs[index].disabled) { this.select(index); break; }
                index += event.key === "ArrowLeft" ? -1 : 1;
            }
            this.$nextTick(() => this.$el.querySelectorAll('[role="tab"]')[this.activeIndex]?.focus());
        },
    },
};
</script>
